import WithScopes from "components/common/WithScopes";
import { SCOPES } from "enums/scopes.enum";
import ProtectedLayout from "layouts/common/general/ProtectedLayout";
import DeviceMonitorLayout from "layouts/app-taxi-ranking/device-monitor";
import NotFound from "pages/common/errors/not-found/NotFound";
import DeviceMonitorPage from "./device-monitor/device-monitor-page";

const root = {
    path: "device-monitor",
    element: (
        <ProtectedLayout>
            <DeviceMonitorLayout />
        </ProtectedLayout>
    ),
    children: [
        {
            path: "",
            element: (
                <WithScopes filterScopes={[SCOPES.VIEW_DEVICE_MONITOR_PAGE]} isFullScreen>
                    <DeviceMonitorPage />
                </WithScopes>
            ),
        },
        {
            path: "page-not-found",
            element: <NotFound />,
        },
    ],
};

export default root;
